import { __rest } from 'tslib';
import React from 'react';
import { View } from 'react-native';
import { InputPin, Choices, Input, Button } from 'react-silk-ui';

class Form extends React.PureComponent {
    constructor(props) {
        super(props);
        const initialFormValues = {};
        props.fields.forEach(field => {
            if (props.initialValues) {
                initialFormValues[field.name] = props.initialValues[field.name];
            }
            else {
                initialFormValues[field.name] = '';
            }
        });
        this.state = {
            values: initialFormValues,
        };
        this.onSubmit = this.onSubmit.bind(this);
    }
    fieldChanged(name, value) {
        this.setState(prevState => ({
            values: Object.assign({}, prevState.values, { [name]: value }),
        }));
    }
    onSubmit() {
        this.props.onSubmit(this.state.values);
    }
    render() {
        return (React.createElement(View, null,
            this.props.fields.map(field => {
                const { type } = field, inputProps = __rest(field, ["type"]);
                switch (type) {
                    case 'password':
                        inputProps.secureTextEntry = true;
                        break;
                    case 'pin':
                        return (React.createElement(InputPin, { key: field.name, fieldStyles: this.props.fieldStyles, onChanged: (value) => this.fieldChanged(field.name, value), label: field.label }));
                    case 'radio':
                        return (React.createElement(Choices, { key: field.name, label: field.label, choices: field.choices, value: this.state.values[field.name], onChanged: (value) => this.fieldChanged(field.name, value) }));
                    case 'checkbox':
                        return (React.createElement(Choices, { key: field.name, label: field.label, mutiple: true, choices: field.choices, value: this.state.values[field.name], onChanged: (value) => this.fieldChanged(field.name, value) }));
                    default:
                        break;
                }
                return (React.createElement(Input, Object.assign({ key: field.name }, this.props.fieldStyles, inputProps, { value: this.state.values[field.name], onChanged: (value) => this.fieldChanged(field.name, value) })));
            }),
            this.props.onSubmit && (React.createElement(Button, Object.assign({ onPress: this.onSubmit }, this.props.submitButton), "Submit"))));
    }
}
var index = { Form };

export default index;
export { Form };
